<template>
  <div class="cover">
    <div :style="`padding-left: ${!userInfo||!userInfo.id?270:0}px;`">
      <Header style="background-color: transparent;" :showSwitch="false">
        <div>
          <span class="head-link" @click="toDevelop">开发者平台</span>
          <span class="head-link" @click="toService">服务商平台</span>
          <span class="head-link" @click="toYiyun">管理后台</span>
          <span class="head-link" @click="toDoc">文档中心</span>
        </div>
        <div slot="right" class="header-right">
          <span v-if="!userInfo||!userInfo.id" style="margin-right: 285px;line-height: 34px;">未登录</span>
          <user-popover v-else></user-popover>
        </div>
      </Header>
    </div>
    <div class="cover-main">
      <div class="title">物联平台</div>
      <div class="desc">成为亦云的合作伙伴，为广大用户提供丰富的工业应用</div>
      <div class="btn-container">
        <template v-if="!userInfo||!userInfo.id">
          <el-button type="primary" size="large" @click="toRegister" plain>申请入驻</el-button>
          <el-button type="primary" size="large" @click="toPlatform" plain>立即登录</el-button>
        </template>
        <el-button type="primary" size="large" v-else @click="$router.push('/main/production')" plain>进入平台</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapMutations} from 'vuex'
import Header from '@/components/Header'
import userPopover from '@/components/userPopover'
import {getCookie} from "../assets/js/utils";
export default {
  name: 'coverPage',
  data () {
    return {
      user: {}
    }
  },
  components: {
    Header,
    userPopover
  },
  mounted () {
    if (!getCookie('Authorization')) {
      this.SET_USERINFO({})
      this.SET_ORGINFO({})
    }
  },
  computed: {
    ...mapMutations('user', ['SET_USERINFO', 'SET_ORGINFO']),
    ...mapState('user',['userInfo','orgInfo'])
  },
  methods: {
    ...mapActions('user',['ExitUser']),
    toPlatform () {
      window.location.href = process.env.VUE_APP_SITE_HOST + '/pc/platform/index.html#/login?platformSource=iotplatform'
    },
    replaceText (text,start,stop,replacetext){
      return text.substr(0,start-1)+replacetext+text.substr(stop+1);
    },
    async logout () {
      await this.ExitUser();
      this.$router.push({path:'/'})
    },
    toRegister () {
      window.location.href = process.env.VUE_APP_SITE_HOST + '/pc/platform/index.html#/login/register?platformSource=iotplatform'
    },
    toDevelop () {
      window.open(process.env.VUE_APP_DEVELOPER_HOST)
    },
    toService() {
      window.open(process.env.VUE_APP_SERVICE_PROVIDER_HOST)
    },
    toYiyun () {
      window.open(process.env.VUE_APP_SITE_HOST + '/pc/platform/index.html#/')
    },
    toDoc () {
      let url = 'https://help.ptest.effio.cn'
      switch (process.env.VUE_APP_MODE) {
        case 'production':
          url = 'https://help.effio.cn/'
          break
        case 'staging':
          url = 'https://staging-help.effio.cn/'
          break
        default:
          break
      }
      window.open(url)
    },
  }
}
</script>

<style scoped lang="less">
.cover{
  width: 100%;
  height: 100%;
  background: url(../assets/images/cover_bg.png) center no-repeat;
  background-size: cover;
  background-color: rgba(0,0,0,0.5);
  color: #fff;
}
.header-right{
  font-size: 14px;
  .btn{
    cursor: pointer;
  }
  .avatar{
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
  }
}
.head-link{
  font-size: 16px;
  margin-right: 59px;
  cursor: pointer;
}
.cover-main{
  width: 100%;
  height: calc(100% - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .title{
    font-size: 50px;
    font-weight: 500;
  }
  .desc{
    font-size: 14px;
    margin-top: 22px;
    margin-bottom: 55px;
  }
  .el-button{
    width: 155px;
    height: 48px;
    font-size: 16px;
    +.el-button{
      margin-left: 30px;
    }
  }
}
.pop-footer{
  margin-left: 11px;
  text-align: center;
}
.pop-divider2{
  left: -11px;
  position: relative;
  width: 211px;
  height: 1px;
  background-color: #EDEDED;
  margin-top: 17px;
  margin-bottom: 11px;
}
.pop-divider1{
  left: -11px;
  position: relative;
  width: 211px;
  height: 1px;
  background-color: #EDEDED;
  margin-top: 11px;
  margin-bottom: 22px;
}
.switch-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-info{
  margin-left: 9px;
}
.user-info,.company{
  color: rgba(0,0,0,0.65);
}
.btn-container {
  margin-bottom: 160px;
}
</style>
